import { hasReplacementsOnProduct } from '@mercadoni/sinister/dist/cjs/shared'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { StoreConfigurations } from '~types/index'

const showReplacementsOnProduct = (
  clientConfig: ClientModel,
  configurations: StoreConfigurations
) => {
  return (
    hasReplacementsOnProduct(clientConfig) &&
    configurations?.allowSubstituteProducts
  )
}
export default showReplacementsOnProduct
